export default {
	deviceList: {
		title: '设备列表',
		total: '设备总数',
		running: '运行',
		stopped: '停机',
		online: '在线',
		offline: '离线',
		lowAlarm: '一般告警',
		mediumAlarm: '中等告警',
		severeAlarm: '严重告警',
		unit: '台',
		noData: '暂无数据',
		deviceName: '设备名称',
		status: {
			running: '运行',
			online: '在线',
			stopped: '停机',
			offline: '离线'
		},
		warnLevel: {
			normal: '正常',
			low: '一般',
			medium: '中等',
			severe: '严重'
		},
		labels: {
			warnLevel: '告警等级',
			runDuration: '本次运行时长（单次）',
			stopDuration: '本次停机时长',
			offlineDuration: '离线时长',
			deviceType: '设备类型'
		},
		imageError: '图片加载失败',
		filter: {
			total: 'total',
			status: {
				running: 'RUN',
				stopped: 'STOP',
				offline: 'OFFLINE'
			}
		},
		sensorGroup: '测点分组',
		configDeviceModel: '配置设备模型',
		sensorManager: '测点管理',
		selectAll: '全选',
		clearAll: '清空',
		maxSensorsTip: '最多显示20个测点',
		editGroup: '编辑分组',
		addGroup: '新增分组',
		groupName: '分组名称',
		groupNameRequired: '请输入分组名称',
		groupNamePlaceholder: '请输入分组名称',
		selectSensor: '选择测点',
		searchSensor: '搜索测点',
		noOptionalSensors: '暂无可选测点',
		onlineStatus: '在线',
		offlineStatus: '离线',
		alarmInfoSuffix: '告警信息',
		messages: {
			updateSuccess: '更新成功',
			updateFailed: '更新失败',
			addSuccess: '新增成功',
			addFailed: '新增失败',
			deleteSuccess: '删除成功',
			deleteFailed: '删除失败',
			save3DSuccess: '3D点位信息保存成功',
			save3DEmpty: '没有3D点位信息需要保存',
			savePointSuccess: '点位信息保存成功',
			set3DModelSuccess: '设备3D模型设置成功',
			set25DSuccess: '设备2.5D图设置成功',
			groupNameRequired: '请输入分组名称',
			sensorRequired: '请至少选择一个测点',
			deleteGroupConfirm: '确定要删除该分组吗？删除后组内测点将恢复未分组状态。',
			deleteGroupSimpleConfirm: '确定要删除该分组吗？',
			confirmTitle: '提示',
			confirm: '确定',
			cancel: '取消'
		},
		warnStatusText: {
			normal: '正常',
			general: '一般',
			medium: '中等',
			severe: '严重'
		}
	},
	deviceDetails: {
		back: '返回',
		featureUpdateTime: '特征值数据更新时间',
		deviceParams: '设备参数',
		deviceInfo: '设备信息',
		deviceNumber: '设备编号',
		deviceNameLabel: '设备名',
		type: '类型',
		orgName: '所属工厂',
		healthDegree: '设备健康度',
		alertStats: '告警统计',
		totalWarnings: '总告警数',
		critical: '严重',
		medium: '中等',
		normal: '一般',
		runOverview: '运行概况',
		startStopRecord: '启停记录',
		operationRate: '运行率',
		totalRunDuration: '运行总时长',
		totalOnlineDuration: '设备在线总时长',
		hour: '小时',
		deviceStatus: '设备状态',
		diagnosticReport: '诊断报告',
		noDiagnosticReport: '暂无诊断报告',
		alarmProcessing: '告警处理',
		startStopTitle: '启停记录',
		status: {
			running: '运行',
			online: '在线',
			stopped: '停机',
			offline: '离线'
		},
		healthStatus: {
			good: '健康状态良好',
			medium: '健康状态一般',
			poor: '健康状态较差'
		},
		healthTip: {
			good: '设备运行良好，建议定期巡检',
			medium: '建议加强设备监控和维护',
			poor: '需要安排设备检修，防止故障发生'
		},
		alertLevel: {
			healthy: '设备健康',
			low: '一般告警',
			medium: '中等告警',
			severe: '严重告警',
			unknown: '未知状态'
		},
		alertDesc: {
			low: '设备运行出现一般异常，请注意观察',
			medium: '设备运行出现中等异常，建议及时处理',
			severe: '设备运行出现严重异常，需要立即处理',
			unknown: '设备状态未知'
		},
		suggestion: '建议关注运行',
		alarmBtn: '告警处理',
		duration: '报警持续时长',
		currentDuration: {
			running: '本次运行时长（单次）',
			stopped: '停机时长',
			offline: '离线时长',
			default: '状态时长'
		},
		offlineTotalDuration: '运行总时长 (离线前)'
	},
	digitalTwin: {
		title: '设备数字孪生',
		digitalModeling: '数字建模',
		realtimeMonitoring: '实时监控',
		monitoringPlaceholder: '现场监控视频接入中，敬请期待',
		deviceSelectTip: '请选择设备',
		noDevice: '暂无设备数据',
		modelLoading: '模型加载中...',
		modelLoadFailed: '模型加载失败',
		electrical: {
			title: '电气参数',
			inverterParams: '变频器运行参数',
			weightInfo: '重量信息',
			deviceStatusWord: '设备状态字',
			ioStatus: '设备IO状态',
			faultInfo: '系统故障信息',
			faultCode: '故障代码',
			normal: '正常',
			fault: '故障',
			bit: '位',
			updateTime: '数据更新时间',
			mechanism: {
				bridge: '大车',
				trolley: '小车',
				hoist: '起升',
				grab: '开闭'
			},
			params: {
				outputVoltage: '输出电压',
				outputCurrent: '输出电流',
				outputTorque: '输出转矩',
				outputSpeed: '输出速度',
				dcBusVoltage: '直流母线电压',
				actualPosition: '实际位置'
			},
			weight: {
				hoist: '起升重量',
				grab: '开闭重量',
				total: '总重量'
			}
		}
	},
	config: {
		gridLayout: '格栅布局',
		deviceName: '设备名称',
		deviceNumber: '设备编号',
		projectNumber: '项目编号',
		status: '状态',
		deviceType: '设备类型',
		org: '机构',
		deviceImage: '设备图片',
		deviceModelImage: '设备模型图',
		sort: '排序',
		placeholder: {
			org: '机构 (诊断)'
		},
		rules: {
			required: '必填项不能为空'
		},
		labels: {
			label1: '标签 1'
		}
	},
	deviceModelLibrary: {
		configDeviceModel: '配置设备模型',
		selectDeviceType: '选择设备类型',
		deviceModelImageAlt: '设备模型图',
		addModelImage: '添加模型图片',
		messages: {
			pleaseSelectModel: '请选择一个设备模型图',
			deleteConfirm: '确定要删除该模型吗?',
			deleteConfirmTitle: '提示',
			deleteConfirmBtn: '确定',
			deleteCancelBtn: '取消',
			deleteSuccess: '删除成功',
			operationSuccess: '操作成功'
		}
	},
	devicePlm: {
		deviceBasicInfo: '设备基础信息',
		editDeviceBasicInfo: '编辑设备基础信息',
		fieldName: '名称',
		fieldValue: '值',
		fieldNamePlaceholder: '名称',
		fieldValuePlaceholder: '值',
		healthHistory: '健康度历史记录',
		date: '日期',
		healthScore: '健康度评分',
		messages: {
			updateSuccess: '设备信息更新成功',
			updateFailed: '设备信息更新失败'
		},
		status: {
			normal: '正常',
			abnormal: '异常',
			warning: '警告',
			maintenance: '维护中'
		}
	}
}
